import { ParsedQuery } from "query-string"
import { Tag } from "../../../types/tag"
import { groupTags } from "../../../utils/tags"
import { SearchControllerParams, TagFilterInput } from "../types"

interface SearchParamsBuilder {
  languageId: string
  categoryCodes?: string[]
  brandCodes?: string[]
  excludeBrandCodes?: string[]
  queryParams: ParsedQuery
  tags?: Tag[]
}

const parseQueryParam = (
  key: string,
  value: string | string[]
): TagFilterInput => ({
  key,
  codes: Array.isArray(value) ? value : [value],
})

const tagParamKeys = ["new", "bestseller"]

const parseTagQueryParams = (
  queryParams: ParsedQuery
): TagFilterInput[] | undefined => {
  const tags = []
  for (const key in queryParams) {
    if (!tagParamKeys.includes(key.toLowerCase())) {
      continue
    }
    const value = queryParams[key]
    if (value) {
      tags.push(parseQueryParam(key, value))
    }
  }
  return tags.length > 0 ? tags : undefined
}

const getExcludeParams = (queryParams: ParsedQuery) => {
  if (!queryParams.exclude) {
    return undefined
  }

  if (typeof queryParams.exclude === "string") {
    return [queryParams.exclude]
  }
  return queryParams.exclude
}

const getDefaultSorting = (layoutData: any) => {
  console.log("s", layoutData)
  if (layoutData?.data?.body?.defaultSearchSort === "weight") {
    return {
      by: "weight",
      direction: "desc",
    }
  }
  return {
    by: "price",
    direction: "asc",
  }
}

export const buildDefaultSearchParams = (
  options: SearchParamsBuilder,
  // remove
  layoutData: any
): SearchControllerParams => {
  const query = parseTagQueryParams(options.queryParams)
  const includeUnavailable = options.queryParams.includeUnavailable === "true"
  return {
    filters: {
      languageId: "it_it",
      categories:
        options.categoryCodes && options.categoryCodes.length > 0
          ? options.categoryCodes
          : undefined,
      brandCodes:
        options.brandCodes && options.brandCodes.length > 0
          ? options.brandCodes
          : undefined,
      excludeBrandCodes:
        options.excludeBrandCodes && options.excludeBrandCodes.length > 0
          ? options.excludeBrandCodes
          : undefined,
      tags:
        options.tags && options.tags.length > 0
          ? groupTags(options.tags)
          : query,
      exclude: getExcludeParams(options.queryParams),
    },
    paging: {
      newSearch: true,
      firstPage: true,
    },
    sorting: getDefaultSorting(layoutData),
    // sorting: {
    //   by: "price",
    //   direction: "asc",
    // },
    includeUnavailable,
  }
}
